import React from 'react'
import './ServiceLog.scss'

export default function ServiceLog(props) {
    return (
        <div className='ServiceLog'>
            {props.time} | {props.user} | {props.action} | {props.service}
        </div>
    )
}